import AmexSecurityCenterHeader from './AmexSecurityCenterHeader';

export default AmexSecurityCenterHeader;
